import React from 'react';
import { bp } from './theme';

// Responsive viewport hook. Replaces the old ad-hoc useIsMobile (768px).
// Returns the flags the shell + grids use to reflow.
export function useViewport() {
  const get = () => ({
    w: typeof window !== 'undefined' ? window.innerWidth : 1440,
    isMobile: typeof window !== 'undefined' ? window.innerWidth < bp.mobile : false,
    isNarrow: typeof window !== 'undefined' ? window.innerWidth < bp.narrow : false,
    isTablet: typeof window !== 'undefined' ? window.innerWidth < bp.tablet : false,
  });
  const [v, setV] = React.useState(get);
  React.useEffect(() => {
    const h = () => setV(get());
    window.addEventListener('resize', h);
    return () => window.removeEventListener('resize', h);
  }, []);
  return v;
}

// Back-compat shim so existing `useIsMobile()` call sites keep working.
export function useIsMobile() {
  return useViewport().isMobile;
}
